export default __webpack_public_path__ + "static/media/professional_portrait.54d4b92e.jpg";